import { useEffect, useRef, useState } from 'react'
import AOS from 'aos'
import { SITE,ROUTES  } from '@/constants'
import Button from '@ui/Button'

import Industries from '@components/Industries'
import StackGrid from '@components/StackGrid'
import { useLocation } from 'react-router-dom'
import Breadcrumb from '@common/Breadcrumb'
import { useInView } from '@helpers/useIntersectionObserver'
import { useScrollSpy } from '@helpers/useIntersectionObserver'
import TransformBanner from '@sections/TransformBanner'
import { buildRows } from '../assets/js/common'

import MetaInfo from '@common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.OUR_EXPERTISE)

// ── Domain chip data ──────────────────────────────────────────────────
const DOMAINS = [
  { name: 'Personal Finance',    color: { bg: '#f7d3cf', text: '#7a3228' } },
  // { name: 'ECG',    color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  { name: 'STQC & GIGW',     color: { bg: '#9bcf60', text: '#2e5a0e' } },
  { name: 'Power & Energy',       color: { bg: '#7fc2eb', text: '#1a4f72' } },
  // { name: 'AI/ML',     color: { bg: '#ece3d0', text: '#5c4a1e' } },
  { name: 'Product Development',     color: { bg: '#a9e5e5', text: '#1a5c5c' } },
  { name: 'Project Management',   color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  // { name: 'Public Distribution Schemes', color: { bg: '#f7d3cf', text: '#7a3228' } },
  // { name: 'Analytics & Reporting',        color: { bg: '#7fc2eb', text: '#1a4f72' } },
  { name: 'Education',           color: { bg: '#9bcf60', text: '#2e5a0e' } },
  { name: 'Wealth Management',      color: { bg: '#ece3d0', text: '#5c4a1e' } },
  // { name: 'Payment Gateways',        color: { bg: '#a9e5e5', text: '#1a5c5c' } },
  { name: 'eGovernance',       color: { bg: '#f7d3cf', text: '#7a3228' } },
  // { name: 'NGO Campaign Management',    color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  // { name: 'Patient Care',         color: { bg: '#9bcf60', text: '#2e5a0e' } },
  { name: 'EV & Automobiles',        color: { bg: '#f7d3cf', text: '#7a3228' } },
  { name: 'Fashion & Photography',       color: { bg: '#7fc2eb', text: '#1a4f72' } },
  { name: 'VAPT & Security Audits',   color: { bg: '#ece3d0', text: '#5c4a1e' } },
  { name: 'Interactive Dashboards',          color: { bg: '#a9e5e5', text: '#1a5c5c' } },
  { name: 'EMR',   color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  { name: 'API Integration',  color: { bg: '#f7d3cf', text: '#7a3228' } },

   { name: 'Oncology',    color: { bg: '#f7d3cf', text: '#7a3228' } },
  // { name: 'Hospital Management',    color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  // { name: 'Clinic Management',     color: { bg: '#9bcf60', text: '#2e5a0e' } },
  // { name: 'Textile',       color: { bg: '#7fc2eb', text: '#1a4f72' } },
  // { name: 'Banking',     color: { bg: '#ece3d0', text: '#5c4a1e' } },
  // { name: 'Retail',     color: { bg: '#a9e5e5', text: '#1a5c5c' } },
  { name: 'Equity & Mutual Funds',   color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  { name: 'Startups', color: { bg: '#f7d3cf', text: '#7a3228' } },
  // { name: 'IT Consulting',        color: { bg: '#7fc2eb', text: '#1a4f72' } },
  // { name: 'D2C',           color: { bg: '#9bcf60', text: '#2e5a0e' } },
  // { name: 'eCommerce',      color: { bg: '#ece3d0', text: '#5c4a1e' } },
  { name: 'ERP',        color: { bg: '#a9e5e5', text: '#1a5c5c' } },
  { name: 'Domain Management',       color: { bg: '#f7d3cf', text: '#7a3228' } },
  // { name: 'Email Management',    color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  // { name: 'Transactional Emails',         color: { bg: '#9bcf60', text: '#2e5a0e' } },
  // { name: 'WhatsApp / SMS Integration',        color: { bg: '#f7d3cf', text: '#7a3228' } },
  { name: 'Hosting Management',       color: { bg: '#7fc2eb', text: '#1a4f72' } },
  { name: 'Income Tax',   color: { bg: '#ece3d0', text: '#5c4a1e' } },
  // { name: 'XBRL',          color: { bg: '#a9e5e5', text: '#1a5c5c' } },
  // { name: 'Neurology',   color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  { name: 'Labs & Diagnostics',  color: { bg: '#f7d3cf', text: '#7a3228' } },

   { name: 'B2C',    color: { bg: '#f7d3cf', text: '#7a3228' } },
  // { name: 'SME Business Automation',    color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  // { name: 'Astrology & Energy Healing',     color: { bg: '#9bcf60', text: '#2e5a0e' } },
  // { name: 'Human Resource',       color: { bg: '#7fc2eb', text: '#1a4f72' } },
]

// function buildRows(items) {
//   const rows = []
//   let i = 0, rowIndex = 0
//   while (i < items.length) {
//     const size = rowIndex % 2 === 0 ? 6 : 5
//     rows.push(items.slice(i, i + size))
//     i += size
//     rowIndex++
//   }
//   return rows
// }


// ── Jump nav ──────────────────────────────────────────────────────────
const NAV_ITEMS = [
  { id: 'tool-technologies',      label: 'TOOLS & TECHNOLOGIES'       },
  { id: 'industries',      label: 'Industries'       },
  { id: 'domain',          label: 'Domain Expertise' },
]

function JumpNav({ activeId }) {
  return (
    <nav className="about-jumpnav" aria-label="Portfolio sections">
      {NAV_ITEMS.map(({ id, label }) => (
        <a
          key={id}
          href={`#${id}`}
          className={`about-jumpnav-link${activeId === id ? ' about-jumpnav-link--active' : ''}`}
        >
          {label}
        </a>
      ))}
    </nav>
  )
}



// ── Page ──────────────────────────────────────────────────────────────
export default function OurExpertise() {

  // useEffect(() => { AOS.refresh(); window.scrollTo(0, 0) }, [])
  const location = useLocation()

useEffect(() => {
  AOS.refresh()

  if (location.hash) {
    // Section elements render asynchronously — wait a tick so the target
    // actually exists in the DOM before trying to scroll to it. A single
    // rAF is usually enough, but a short timeout is more reliable across
    // slower devices/AOS's own layout shifts.
    const id = location.hash.slice(1)
    const timer = setTimeout(() => {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 150)
    return () => clearTimeout(timer)
  }

  window.scrollTo(0, 0)
}, [location.hash])

  const domainRows = buildRows(DOMAINS)
  const sectionIds   = NAV_ITEMS.map(n => n.id)  
  const activeId   = useScrollSpy(sectionIds, { rootMargin: '-20% 0px -70% 0px' })

  return (
    <> 
    {/* <MetaInfo
        title="Our Expertise | CruxBytes"
        description="Explore the tools, technologies, industries and domain expertise behind CruxBytes software solutions, from eGovernance and healthcare to finance, startups and ERP."
        keywords="technology expertise, software development technologies, industry expertise, domain expertise, eGovernance, ERP, healthcare software, CruxBytes"
      /> */}
       <MetaInfo
     title={label}
      description={metaDesc}
      keywords=""
      />
    <main id="main-content" className="page-wrapper">

      {/* ── Hero ── */}
      <div className="page-hero page-hero-small">
        <div className="bg-grid bg-grid--fill" aria-hidden="true" />
        <div className="container">
          
          <Breadcrumb />
          <h1 data-aos="fade-up" data-aos-delay={100}>
            {/* Our Expertise */}
            {label}
            </h1>
          <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
            {/* Varied Tools, diverse industries, unique challenges, proven technology expertise. */}
            {pageDesc}
          </p>
          
          <div className="inner-page-actions">
             <Button href={ROUTES.OUR_WORK} variant="secondary" data-aos="fade-left" data-aos-delay={300}>
              View our projects
            </Button>
            <Button href={ROUTES.SALES_ENQUIRY} variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-right" data-aos-delay={300}>
              Ask for a free quote ?
            </Button>
          
          </div>  
        </div>
      </div>

      {/* ── Jump nav + sections ── */}
      <div className="section-py about-us-content">
        <div className="container about-us-layout">

          {/* LEFT — sticky jump nav */}
          <aside className="jumpnav-wrap">
            <JumpNav activeId={activeId} />
          </aside>

          {/* RIGHT — scrollable sections */}
          <div className="about-us-sections">

            {/*  1 ── TOOLS & TECHNOLOGIES */}
            <section
              id="tool-technologies"
              className="about-us-section pf-section"
              aria-labelledby="pf-domain-heading"
              data-aos="fade-up"
            >
              <h2 id="pf-tool-technologies" className="section-heading">We Adapt, You Benefit</h2>
              <p className="about-us-section-body">
CruxBytes has a rich experience in working with emerging technologies and has built extensive experience in various programming languages, frameworks, libraries, and tools.
</p><p className="about-us-section-body">
We continuously experiment with new technologies through our young talented engineers and pass on the learnings to our clients for a competitive edge.
              </p>
              <div className="domain-grid" aria-label="List of industries we serve">
              <StackGrid />
              </div>
            </section>

            {/* 1.2 ── Industries */}
            <section
              id="industries"
              className="about-us-section pf-section"
              aria-labelledby="pf-industries-heading"
              data-aos="fade-up"
            >
              <h2 id="industries-heading" className='section-heading'>Industries We Cater</h2>
              <p className="about-us-section-body">
                From government initiatives to fast-scaling startups — we bring deep
                domain experience across sectors that matter.
              </p>
              <div className="pf-orbit-wrap">
                <Industries />
              </div>
            </section>

            {/* 2 ── Domain Expertise */}
            <section
              id="domain"
              className="about-us-section pf-section"
              aria-labelledby="pf-domain-heading"
              data-aos="fade-up"
            >
              <h2 id="pf-domain-heading" className="section-heading">Domain Expertise</h2>
              <p className="about-us-section-body">
                Every business deserves technology solutions built around its needs —
                not generic packages. We deliver customised, scalable, AI-enabled IT
                services that evolve with your business.
              </p>
              <div className="domain-grid" aria-label="List of industries we serve">
                {domainRows.map((row, rowIdx) => (
                  <div key={rowIdx} className="domain-row">
                    {row.map((domain, chipIdx) => (
                      <span
                        key={domain.name}
                        className="domain-chip"
                        style={{ '--chip-bg': domain.color.bg, '--chip-text': domain.color.text }}
                        data-aos="fade-up"
                        data-aos-delay={chipIdx * 30}
                      >
                        {domain.name}
                      </span>
                    ))}
                  </div>
                ))}
              </div>
            </section>

          </div>{/* end about-us-sections */}
        </div>{/* end about-us-layout */}
      </div>
<TransformBanner />
    </main>
    </>
  )
}